import { AlertTriangle, CheckCircle2 } from 'lucide-react';

/**
 * 帯の見た目の種類。warning は警告（読み上げ対象の alert）、ok は平常の状態表示。
 * @graph-connects none
 */
type StatusBannerTone = 'warning' | 'ok';

/**
 * 画面の見出しの下に置く1行の帯。データの鮮度や取り込みの状態を知らせる。
 *
 * FAQ監視の鮮度帯と問い合わせ分析の「未取得」帯が同じ見た目になるよう、見た目はここにだけ置く。
 * 本文（message）と、警告時に強調する一言（emphasis）の2つを並べる。
 *
 * @graph-stack ac-mens-hub
 * @graph-domain Operations
 * @graph-business 鮮度や取り込みの状態を、警告なら琥珀色の alert、平常なら控えめな色の1行の帯で表示する
 * @graph-connects none
 */
export function StatusBanner({
  tone,
  message,
  emphasis,
}: {
  tone: StatusBannerTone;
  message: string;
  emphasis?: string;
}) {
  const warning = tone === 'warning';

  return (
    <div
      className={`flex items-center gap-2 rounded-md border px-3 py-2 text-sm ${
        warning
          ? 'border-amber-500/20 bg-amber-500/10 text-amber-700 dark:text-amber-400'
          : 'border-border bg-background-secondary text-foreground-secondary'
      }`}
      role={warning ? 'alert' : undefined}
    >
      {warning ? (
        <AlertTriangle className="h-4 w-4 shrink-0" aria-hidden="true" />
      ) : (
        <CheckCircle2 className="h-4 w-4 shrink-0" aria-hidden="true" />
      )}
      <span>{message}</span>
      {emphasis !== undefined && <span className="font-medium">{emphasis}</span>}
    </div>
  );
}
